import React, { Component } from 'react';
import Select from 'react-select';
import IndexTabs from './Accounting/IndexTabs'
import MainDrawer from './InternalNavigation/drawer';
import InternalNavigation from './InternalNavigation';
import { BottomRow } from './shared/BottomRow'
import IndexHeaders from './Accounting/IndexHeaders'
import TipsHeaders from './Accounting/TipsHeaders'
import AccountingTable from './Accounting/AccountingTable'
import { ScrollSync } from 'react-scroll-sync'
import Plot from 'react-plotly.js';
import { selectors, actions } from './sagas/accounting'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import moment from 'moment';
import KmDatePicker from './shared/KmDatePicker'
import './stylesheets/accounting.sass'
import './stylesheets/inventory.sass'

class Accounting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drawer: false,
      tab: 'accounting'
    };
    this.props.getTimeSeries()
    this.props.getTotals()
    this.props.getTips()
    this.props.getAccounting()
  }

  toggleDrawer = () => {
    this.setState({drawer: !this.state.drawer})
  }

  setTab = (tab) => {
    this.setState({tab: tab})
  }

  render () {
    return (
      <div>
        <MainDrawer
          position={'left'}
          openState={this.state.drawer}
          toggleDrawer={this.toggleDrawer}
          className='drawer'/>
        <InternalNavigation
          toggleDrawer={this.toggleDrawer}/>
        <div className='accounting'>
          <div className={'top-row'}>
            <div className='accountings-title'>
              Accounting
            </div>
            <div className={'time-selector'}>
              <TimeSelector
                range={ this.props.range }
                setDate={ this.props.setRange }
              />
              { this.props.range == 'custom' &&
                <div className={'date-pickers'}>
                  <KmDatePicker
                    label={'Start Date'}
                    wrapperClass={'half-size'}
                    date={ this.props.startDate }
                    change={ this.props.setStartDate }
                  />
                  <KmDatePicker
                    label={'End Date'}
                    wrapperClass={'half-size'}
                    date={ this.props.endDate }
                    change={ this.props.setEndDate }
                  />
                </div>
               }
             </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
            {
            this.props.timeSeries &&
            this.props.timeSeriesLoaded &&
            <Plot
              data={[
                {
                  x: this.props.timeSeries[0],
                  y: this.props.timeSeries[1],
                  name: 'Daily Revenue',
                  type: 'bar',
                  mode: 'points',
                  marker: {color: '#FDBF20' },
                },
                ]}
              layout={{width: window.innerWidth*.75, height: window.innerHeight*.5, title: 'Daily Revenue'}}
            />
           }
          </div>
          { this.props.totals &&
            <div className={'account-totals row'}>
              <div className={'total-box'}>
                Total Kegs Sold
                <div className={'total-number'}>
                  { this.props.totals && this.props.totals['totalKegs'] }
                </div>
              </div>
              <div className={'total-box'}>
                Total Revenue
                <div className={'total-number'}>
                  ${ this.props.totals && this.props.totals['totalRevenue'] && Number(this.props.totals['totalRevenue']).toFixed(2) }
                </div>
              </div>
              <div className={'total-box'}>
                Total Tips
                <div className={'total-number'}>
                  ${ this.props.totals && this.props.totals['totalTips'] && Number(this.props.totals['totalTips']).toFixed(2) }
                </div>
              </div>
              <div className={'total-box'}>
                Total Tax
                <div className={'total-number'}>
                  ${ this.props.totals && this.props.totals['totalTaxes'] && Number(this.props.totals['totalTaxes']).toFixed(2) }
                </div>
              </div>
              <div className={'total-box'}>
                Total Deposits
                <div className={'total-number'}>
                  ${ this.props.totals && this.props.totals['totalDeposits'] && Number(this.props.totals['totalDeposits']).toFixed(2) }
                </div>
              </div>
            </div>
          }
          <ScrollSync>
            <div>
              <IndexTabs setTab={ this.setTab } activeTab={ this.state.tab }/>
              { this.state.tab == 'accounting' && <IndexHeaders /> }
              { this.state.tab == 'tips' && <TipsHeaders /> }
              <AccountingTable
                activeTab={ this.state.tab }
                tips={ this.props.tips }
                accounting={ this.props.accounting }
              />
            </div>
          </ScrollSync>
          <BottomRow
            widthClass={'bottom-row-5'}
          />
        </div>
      </div>
    );
  }

};

const TimeSelector = (props) => {
  return (
    <Select
      className='km-select m-r-30'
      name="form-field-name"
      style={
        {
          'color': '#333',
          'backgroundColor': '#F9F9F9',
          'outline': 'none',
          'borderColor':'none'
        }
      }
      optionClassName='km-select'
      value={ props.range }
      onChange={ props.setDate }
      options={
        [
          { value: 'day', label: 'Today' },
          { value: 'week', label: 'Previous 7 days' },
          { value: 'month', label: 'Previous 30 days' },
          { value: 'year', label: 'Previous 1 year' },
          { value: 'mtd', label: 'Month to Date' },
          { value: 'ytd', label: 'Year to Date' },
          { value: 'custom', label: 'Custom' },
        ]
      }
    />
 )
}

const mapStateToProps = (store) => ({
  timeSeries: selectors.time_series(store),
  timeSeriesLoaded: selectors.timeSeriesLoaded(store),
  totals: selectors.totals(store),
  range: selectors.range(store),
  accounting: selectors.accounting(store),
  tips: selectors.tips(store),
  startDate: selectors.startDate(store),
  endDate: selectors.endDate(store)
})

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch)

export default (connect(mapStateToProps, mapDispatchToProps)(Accounting))



// WEBPACK FOOTER //
// ./src/Accounting.jsx